<script lang="ts">import { stateTheme, Theme } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isSpecialWidthCase } from "@infinitro/global";
import { Text } from "@infinitro/text";
import { get } from "svelte/store";
import CalendarFinish from "../../icons/calendar-finish.svg";
import CalendarStart from "../../icons/calendar-start.svg";
import FomoCalendarFinish from "../../icons/fomoio-calendar-finish.png";
import FomoCalendarStart from "../../icons/fomoio-calendar-start.png";
const theme = get(stateTheme);
const calendarIcons = {
	flush: {
		start: CalendarStart,
		finish: CalendarFinish
	},
	fomo: {
		start: FomoCalendarStart,
		finish: FomoCalendarFinish
	},
	rocketbet: {
		start: FomoCalendarStart,
		finish: FomoCalendarFinish
	},
	luna: {
		start: FomoCalendarStart,
		finish: FomoCalendarFinish
	},
	turboslots: {
		start: FomoCalendarStart,
		finish: FomoCalendarFinish
	},
	dynamic: {
		start: CalendarStart,
		finish: CalendarFinish
	}
};
const themeCalendarIcons = calendarIcons[theme] || calendarIcons.flush;
export let isDetail = false;
export let promo;
export let active = true;
export let isNew = false;
export let isBigScreen = false;
const formatDateFromUtcToLocale = (date) => {
	return date ? date.toLocaleDateString("en-GB", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric"
	}) : "Weekly";
};
</script>

{#if $isMobile}
	<div class="mobile-promo-info-container">
		<div class="mobile-promo-info">
			<Text type="body" customStyle="font-size: 12px !important; font-weight: bold !important;">
				{$t(promo.title)}
			</Text>

			<div
				class="mobile-active-badge {!active ? 'mobile-inactive-badge' : ''} {isNew
					? 'mobile-new-badge'
					: ''}"
			>
				<span>
					{#if active}
						{isNew ? $t(Verbiage.new) : $t(Verbiage.active)}
					{:else}
						{$t(Verbiage.inactive)}
					{/if}
				</span>
			</div>
		</div>

		<div class="mobile-promo-info-date mobile-promo-info-mobile-date">
			<span class="mobile-d-flex">
				<img src={CalendarStart} alt={$t(Verbiage.calendar_icon_alt, 'alts')} class="mobile-icon" />
				<Text type="body" textColor="gray" customStyle="font-size: 10px !important;">
					{promo.startDate ? $t(Verbiage.started) : $t(Verbiage.period)}:
				</Text>
				<Text type="body" customStyle="font-size: 10px !important;">
					{formatDateFromUtcToLocale(promo.startDate)}
				</Text>
			</span>

			<span class="mobile-d-flex">
				<img
					src={CalendarFinish}
					alt={$t(Verbiage.calendar_icon_alt, 'alts')}
					class="mobile-icon"
				/>
				<Text type="body" textColor="gray" customStyle="font-size: 10px !important;">
					{$t(Verbiage.finishes)}:
				</Text>
				<Text type="body" customStyle="font-size: 10px !important;">
					{formatDateFromUtcToLocale(promo.endDate)}
				</Text>
			</span>
		</div>
	</div>
{:else}
	<div class="promo-info-container {isDetail && 'promo-info-container-detail'}">
		<div class="promo-info {isDetail && 'promo-info-detail'}">
			{#if isDetail}
				<Text type="title" titleSize="h4" titleWeight="bold">
					{$t(promo.title)}
				</Text>
			{:else}
				<div class="promotion-title-container">
					<p
						class:promotion-title-text={!$isSpecialWidthCase}
						class:promotion-title-text-special={$isSpecialWidthCase}
					>
						{$t(promo.title)}
					</p>
				</div>
			{/if}
			{#if !isDetail}
				<div class="active-badge {!active ? 'inactive-badge' : ''} {isNew ? 'new-badge' : ''}">
					<span>
						{#if active}
							{isNew ? $t(Verbiage.new) : $t(Verbiage.active)}
						{:else}
							{$t(Verbiage.inactive)}
						{/if}
					</span>
				</div>
			{/if}
		</div>

		<div class="promo-info-date {isDetail && 'promo-info-detail-date'}">
			<span class="d-flex">
				<img
					src={themeCalendarIcons.start}
					alt={$t(Verbiage.calendar_icon_alt, 'alts')}
					class="icon"
				/>
				<Text
					type="body"
					textColor="gray"
					bodySize="small"
					bodyWeight="regular"
					customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'customStyle="font-size: 12px !important;"'}`}
				>
					{promo.startDate ? $t(Verbiage.started) : $t(Verbiage.period)}:
				</Text>
				<Text
					type="body"
					bodyWeight="regular"
					bodySize="small"
					customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'customStyle="font-size: 12px !important;"'}`}
				>
					{formatDateFromUtcToLocale(promo.startDate)}
				</Text>
			</span>
			{#if isDetail}
				<div class="active-badge {!active ? 'inactive-badge' : ''} {isNew ? 'new-badge' : ''}">
					<span>
						{#if active}
							{isNew ? $t(Verbiage.new) : $t(Verbiage.active)}
						{:else}
							{$t(Verbiage.inactive)}
						{/if}
					</span>
				</div>
			{/if}
			{#if promo.endDate}
				<span class="d-flex">
					<img
						src={themeCalendarIcons.finish}
						alt={$t(Verbiage.calendar_icon_alt, 'alts')}
						class="icon"
					/>
					<Text
						type="body"
						textColor="gray"
						bodySize="small"
						bodyWeight="regular"
						customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'customStyle="font-size: 12px !important;"'}`}
					>
						{$t(Verbiage.finishes)}:
					</Text>
					<Text
						type="body"
						bodySize="small"
						bodyWeight="regular"
						customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'customStyle="font-size: 12px !important;"'}`}
					>
						{formatDateFromUtcToLocale(promo.endDate)}
					</Text>
				</span>
			{/if}
		</div>
	</div>
{/if}

<style>
	/* ─────── Desktop ─────── */

	.promotion-title-container {
		max-width: 70%;
}
	.promotion-title-text {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 18px;
		font-weight: 600;
}
	.promotion-title-text-special {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
}

	.promo-info-container {
		display: none;
		width: 100%;
		flex-direction: column;
		row-gap: 0.25rem;
		padding-top: 0.125rem;
		padding-bottom: 0.125rem;
}
	@media (min-width: 1024px) {
		.promo-info-container {
				display: flex;
		}
	}

	.promo-info {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
}
	.promo-info-detail {
		justify-content: center;
}

	.promo-info-date {
		width: 100%;
		flex-direction: column;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
}
	.promo-info-detail-date {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 2rem;
}

	.icon {
		margin-bottom: 2px;
		height: 0.75rem;
		width: 0.75rem;
}
	.d-flex {
		margin-bottom: 0.5rem;
		margin-top: 0.25rem;
		display: flex;
		align-items: center;
		gap: 0.25rem;
}

	.active-badge {
		display: flex;
		max-width: -moz-fit-content;
		max-width: fit-content;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		padding: 0.5rem;
		font-size: 0.6rem;
		font-weight: 700;
		text-transform: uppercase;
		line-height: 0;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		background-image: linear-gradient(
			180deg,
			var(--color-primary-100) 0%,
			var(--color-primary-500) 100%
		);
}
	.inactive-badge {
		background-image: linear-gradient(
			180deg,
			var(--color-error-100) 0%,
			var(--color-error-500) 100%
		);
	}
	.new-badge {
		background-image: linear-gradient(
			180deg,
			var(--color-accent-100) 0%,
			var(--color-accent-500) 100%
		);
	}

	/* ─────── Mobile ─────── */

	.mobile-promo-info-container {
		display: flex;
		min-height: 50px;
		width: 100%;
		flex-direction: column;
		justify-content: center;
		gap: 0.25rem;
}
	.mobile-promo-info {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		padding-left: 0.125rem;
		padding-right: 0.125rem;
		font-weight: 700;
}
	.mobile-promo-info-date {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		padding-left: 0.125rem;
		padding-right: 0.125rem;
}
	.mobile-promo-info-mobile-date {
		display: flex;
		align-items: flex-start;
}
	@media (min-width: 1024px) {
		.mobile-promo-info-mobile-date {
				flex-direction: row;
				align-items: center;
		}
	}

	.mobile-d-flex {
		display: flex;
		align-items: center;
		gap: 0.25rem;
}
	.mobile-icon {
		margin-bottom: 2px;
		height: 0.75rem;
		width: 0.75rem;
}

	.mobile-active-badge {
		display: flex;
		max-width: -moz-fit-content;
		max-width: fit-content;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		padding-top: 0.125rem;
		padding-bottom: 0.125rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-size: 9px;
		font-weight: 700;
		text-transform: uppercase;
		line-height: 1;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		background: var(--gradient-primary);
		font-family: var(--font-main);
}
	.mobile-inactive-badge {
		background: var(--gradient-error);
}
	.mobile-new-badge {
		background: var(--gradient-secondary);
}
</style>
